import Grid from '@mui/material/Grid';
import { TextField } from '@mui/material';
import React from 'react';
import { DrugAmountState } from '../../../types/DrugDosages.type';
import { DrugSelect } from '../SharedComponents/DrugSelect';
import { ResultText } from '../SharedComponents/ResultText';
import { CalculateButton } from '../SharedComponents/CalculateButton';
import { CalculatorRowTitleGridItem } from '../SharedComponents/CalculatorRowTitleGridItem';
import { numberInputProps } from '../../../config/constant.params';

export const DrugAmountRow = ({
  state,
  handleInputChange,
  handleCalculateClick,
  mobile,
}: {
  state: DrugAmountState;
  handleInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleCalculateClick: () => void;
  mobile: boolean;
}) => {
  return (
    <Grid container spacing={2}>
      <CalculatorRowTitleGridItem>
        CALCULATE AMOUNT OF DRUG SUBSTANCE
      </CalculatorRowTitleGridItem>
      <Grid item xs={8} sm={2}>
        <TextField
          name="strength"
          label="Strength"
          fullWidth
          variant="outlined"
          type="number"
          onChange={handleInputChange}
          value={state.strength.value}
          error={state.strength.error}
          inputProps={numberInputProps}
          autoComplete="off"
        />
      </Grid>
      <Grid item xs={8} sm={2}>
        <DrugSelect
          value={state.mgPerUnit.value}
          error={state.mgPerUnit.error}
          handleChange={handleInputChange}
        />
      </Grid>
      <Grid item xs={8} sm={2}>
        <TextField
          name="numberOfUnits"
          label="Number of units"
          fullWidth
          variant="outlined"
          type="number"
          onChange={handleInputChange}
          value={state.numberOfUnits.value}
          error={state.numberOfUnits.error}
          inputProps={numberInputProps}
          autoComplete="off"
        />
      </Grid>
      <Grid item xs={8} sm={2}>
        <CalculateButton
          handleCalculateClick={handleCalculateClick}
          mobile={mobile}
        />
      </Grid>
      <Grid item xs={6} sm={2}>
        <TextField
          name="result"
          label="Result"
          fullWidth
          variant="outlined"
          type="number"
          disabled
          onChange={handleInputChange}
          value={state.result}
        />
      </Grid>
      <Grid item xs={6} sm={2}>
        <ResultText>mg/kg</ResultText>
      </Grid>
    </Grid>
  );
};
